import React from 'react'

interface AuthorizedFallbackDisplayProps {
  visible: boolean
  width?: string
  authorizedDisplay: React.ReactNode
  fallbackDisplay: React.ReactNode
}

const AuthorizedFallbackDisplay: React.FC<AuthorizedFallbackDisplayProps> = ({
  visible,
  authorizedDisplay,
  fallbackDisplay,
  width,
}) => {
  return (
    <div className="auth-container" style={{ width: width ? width : '100%' }}>
      {visible ? authorizedDisplay : fallbackDisplay}
    </div>
  )
}

export default AuthorizedFallbackDisplay
